export const catchUpHeaderLabel = "HOTx3b";
export const headlinesHeaderLabel = "YbLAW";
export const priorityViewLabel = "zljIge";
export const needsReplyViewLabel = "u1f2Sd";
export default {catchUpHeaderLabel,headlinesHeaderLabel,priorityViewLabel,needsReplyViewLabel};